import { ChatConversationFilters } from "../../../../lib/api/resources/chat";
import dayjs from "dayjs";

export type InboxScope = "unhandled" | "all" | "archived";

/**
 * Compact relative time for an inbox row: time today, "Gisteren", a day count in
 * the last week, otherwise a short date.
 */
export const formatInboxTime = (iso: string | null): string => {
  if (!iso) return "";

  const date = dayjs(iso);
  const diffDays = dayjs().diff(date, "day");

  if (diffDays === 0) return date.format("HH:mm");
  if (diffDays === 1) return "Gisteren";
  if (diffDays < 7) return `${diffDays} dagen geleden`;
  return date.format("D MMM");
};

export const scopeToFilters = (scope: InboxScope): ChatConversationFilters => {
  switch (scope) {
    case "unhandled":
      // `unhandled` already excludes archived conversations server-side.
      return { unhandled: true };
    case "archived":
      return { archived: true };
    default:
      return {};
  }
};

export const unavailableMessage = (reason: string | null): string => {
  switch (reason) {
    case "no_active_configuration":
      return "Er is geen actieve chatconfiguratie voor dit kanaal.";
    case "no_recipient_phone_number":
      return "Dit dossier heeft geen telefoonnummer om naar te sturen.";
    default:
      return "Er kan op dit moment geen bericht worden verstuurd.";
  }
};
